import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/lib/i18n";
import Reveal, { Kicker } from "@/components/Reveal";
import Seo from "@/components/Seo";
import SponsorsMarquee from "@/components/SponsorsMarquee";
import { Button } from "@/components/ui/button";

const SPONSOR_MAILTO = "mailto:office@latschenwirt.at?subject=Sponsoring%20Anfrage%20%E2%80%93%20Krampus-Show%202026";

export default function Sponsors() {
  const { t } = useLang();
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    api.get("/sponsors").then((r) => setSponsors(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="sponsors-page" className="pt-28 md:pt-36 pb-24">
      <Seo path="/sponsoren" title="Sponsoren & Partner der Krampus-Show 2026 | Latschenwirt" titleEn="Sponsors & Partners of the Krampus Show 2026 | Latschenwirt" description="Die Partner der Krampus-Show am Untersberg – und wie dein Unternehmen Sponsor der Show 2026 in Großgmain wird." descriptionEn="The partners of the Krampus Show at Mount Untersberg – and how your company becomes a sponsor of the 2026 show in Grossgmain." />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal className="mb-16 text-center">
          <Kicker>{t("sponsors_kicker")}</Kicker>
          <h1 className="font-display text-5xl md:text-7xl headline-gold mt-4 mb-6 ember-glow">{t("sponsors_hero_t")}</h1>
          <p className="text-hell-smoke max-w-2xl md:mx-auto text-base md:text-lg">{t("sponsors_hero_d")}</p>
        </Reveal>

        <Reveal className="mb-24 -mx-5 md:-mx-10">
          <SponsorsMarquee sponsors={sponsors} />
        </Reveal>

        <Reveal>
          <div className="max-w-2xl mx-auto border border-white/10 bg-hell-coal p-8 md:p-12 text-center">
            <h2 className="font-display text-3xl text-hell-bone mb-4">{t("apply_title")}</h2>
            <p className="text-hell-smoke leading-relaxed mb-8">{t("apply_mail_hint")}</p>
            <a href={SPONSOR_MAILTO}>
              <Button data-testid="sponsor-mailto-cta"
                className="rounded-full bg-hell-red hover:bg-hell-redhot text-hell-bone font-cinzel tracking-[0.15em] uppercase text-xs px-8 h-12 transition-all duration-300 hover:shadow-[0_0_20px_rgba(139,0,0,0.6)]">
                <Mail className="w-4 h-4 mr-2" />
                {t("apply_cta")}
              </Button>
            </a>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
